document.addEventListener('DOMContentLoaded', function() {
    let cl_title = '';
    const prefix_selector = "offer-popup"
    const popupOverlay = document.getElementById(`${prefix_selector}__overlay`);
    const productsGrid = popupOverlay.querySelector(`#${prefix_selector}__products-grid`);
    const addToCartBtn = popupOverlay.querySelector(`#${prefix_selector}__add-to-cart-btn`);
    const grandQuantityElement = popupOverlay.querySelector(`#${prefix_selector}__grand-quantity`);
    const grandTotalElement = popupOverlay.querySelector(`#${prefix_selector}__grand-total`);
    const popupWrap= popupOverlay.querySelector(`#${prefix_selector}____container`);
    let currentProducts = [];
    let cartItems = {};
    function observeOfferButtons() {
        const selector = `.${prefix_selector}__button`;

        function bindButton(btn) {
            if (btn.dataset.bound === 'true') return;

            btn.dataset.bound = 'true';
            btn.addEventListener('click', function () {
                const isInMultiOffer= this.dataset.multipleOffer;
                if(isInMultiOffer == "true"){
                //    const offers=this.dataset.offers;
                let offersStr = this.dataset.offers.replace(/&quot;/g, '"').trim();

  let offers;
try {
offers = JSON.parse(offersStr);
loadOffer(offers);
} catch (err) {
console.error('Invalid offers JSON', err, offersStr);
return;
}

                }else{
                const offerCollectionHandle = this.dataset.offerCollectionHandle;
                const offerTitle = this.dataset.offerTitle;
                const offerDescription = this.dataset.offerDescription;
                const qtyTrashhold = this.dataset.offerQty;
                cl_title = this.dataset.title;
                loadOfferProducts(
                    offerCollectionHandle,
                    offerTitle,
                    offerDescription,
                    qtyTrashhold
                );
            }
            });
        }

        // Bind existing buttons (if already in DOM)
        document.querySelectorAll(selector).forEach(bindButton);

        // Observe future buttons
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType !== 1) return;

                    if (node.matches?.(selector)) {
                        bindButton(node);
                    }

                    node.querySelectorAll?.(selector).forEach(bindButton);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    observeOfferButtons(); // new added at 26-Dec-2025


    // Close popup
    popupOverlay.querySelectorAll(`.${prefix_selector}__close-btn`).forEach(btn => {
        btn.addEventListener('click', closePopup);
    });

    // Close popup when clicking outside
    popupOverlay.addEventListener('click', function(e) {
        if (e.target === popupOverlay) closePopup();
    });
function loadOffer(offers) {
            popupOverlay.classList.add('active');

    if (!Array.isArray(offers) || offers.length === 0) {
        console.warn('No offers available');
        return;
    }

    // Create a container inside popup for offer buttons
    let offerButtonsContainer = popupOverlay.querySelector(`.${prefix_selector}__offer-buttons`);
    if (!offerButtonsContainer) {
        offerButtonsContainer = document.createElement('div');
        offerButtonsContainer.className = `${prefix_selector}__offer-buttons`;
        // Insert before products grid
        productsGrid.parentNode.insertBefore(offerButtonsContainer, productsGrid);
    }
    offerButtonsContainer.innerHTML = '';

    const titleEl = document.createElement('div');
    titleEl.className = `${prefix_selector}__offer-buttons-title h3`;
    titleEl.textContent = "בחר את ההנחה שברצונך לרכוש"; // Hebrew title
    offerButtonsContainer.appendChild(titleEl);

    // Clear previous buttons
    offerButtonsContainer.classList.remove('hidden');
    offerButtonsContainer.classList.add('active');
        popupOverlay.querySelector(`.${prefix_selector}__header`)?.classList.add('hidden');
        popupOverlay.querySelector(`.${prefix_selector}__products-header`)?.classList.add('hidden');
        productsGrid.classList.add('hidden');
        popupOverlay.querySelector(`.${prefix_selector}__popup-footer`)?.classList.add('hidden');

    // Render a button for each offer
    offers.forEach((offer, index) => {
        const btn = document.createElement('button');
        btn.className = `${prefix_selector}__select-offer-btn button button--primary`;
        btn.textContent = offer.title || `Offer ${index + 1}`;
        btn.dataset.handle = offer.handle;
        btn.dataset.title = offer.title || "";
        btn.dataset.description = offer.description || "";
        btn.dataset.qty = offer.qty || 0;
        btn.addEventListener('click', function() {
            // Load products for selected offer
            loadOfferProducts(
                this.dataset.handle,
                this.dataset.title,
                this.dataset.description,
                this.dataset.qty
            );
            cl_title = this.dataset.title;
            // Optionally, highlight selected offer
            offerButtonsContainer.querySelectorAll('button').forEach(b => b.classList.remove('active'));
            this.classList.add('active');
        });

        offerButtonsContainer.appendChild(btn);
    });

    // Optional: auto-select first offer
    // offerButtonsContainer.querySelector('button')?.click();
}

    function loadOfferProducts(offerCollectionHandle, offerTitle="קבל הנחות על מוצרים", offerDescription,qtyTrashhold) {
        popupOverlay.querySelector(`.${prefix_selector}__offer-buttons`)?.classList.remove('active');
        popupOverlay.querySelector(`.${prefix_selector}__offer-buttons`)?.classList.add('hidden');
        popupOverlay.querySelector(`.${prefix_selector}__header`)?.classList.remove('hidden');
        popupOverlay.querySelector(`.${prefix_selector}__products-header`)?.classList.remove('hidden');
        popupOverlay.querySelector(`.${prefix_selector}__popup-footer`)?.classList.remove('hidden');
        productsGrid.classList.remove('hidden');

        // Change Popup Title
        const popupTitle = popupOverlay.querySelector(`.${prefix_selector}__title`);

        if(popupTitle) popupTitle.innerHTML = offerTitle;
       const popupDescription = popupOverlay.querySelector(`.${prefix_selector}__description`);
        if(popupDescription) popupDescription.innerHTML = offerDescription;
        grandQuantityElement.setAttribute("data-qty-trashhold",qtyTrashhold);
        // Show loading state
        productsGrid.innerHTML = `<div class="${prefix_selector}__loading-spinner">טוען מוצרים...</div>`;
        popupOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        fetch(`/collections/${offerCollectionHandle}/products.json`)
        .then(response => response.json())
        .then(data => {
            currentProducts = data.products;
            console.log("data",data);
            renderProducts(currentProducts);
            resetCart();
        })
        .catch(error => {
            console.error('Error loading products:', error);
            productsGrid.innerHTML = `<div class="${prefix_selector}__loading-error">שגיאה בטעינת מוצרים. אנא נסה שוב.</div>`;
        });
    }

    function renderProducts(products) {
        productsGrid.innerHTML = '';

        products.forEach((product, index) => {
            const productRow = document.createElement('div');
            productRow.className = `${prefix_selector}__product-row`;
            productRow.innerHTML = `
                <div class="${prefix_selector}__product">
                    <div class="${prefix_selector}__product-image-box">
                        ${product.images[0]?.src ? `
                            <img 
                            src="${product.images[0] ? product.images[0].src : '//via.placeholder.com/80'}" 
                            alt="${product.title}" 
                            class="${prefix_selector}__product-image"
                            loading="lazy"
                            width="100%"
                            height="100%"
                            >
                        ` : `
                            <svg class="placeholder-svg" preserveAspectRatio="xMidYMid slice" width="448" height="448" viewBox="0 0 448 448" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_894_1529)">
                                    <path d="M448 0H0v448h448V0Z" fill="#F2F2F2"></path>
                                    <path d="m354.54 158.19-33.31-35.87a59.971 59.971 0 0 0-32.2-18.01l-20.99-4.2c-2.72-.49-5.45-.93-8.17-1.33l-.01.01v-.01c-1.29-.21-2.58-.31-3.88-.29-1.3.01-2.6.14-3.88.38l-7.25 1.36-7.08 1.33c-4.54.85-9.13 1.28-13.72 1.27-4.59 0-9.19-.42-13.72-1.27l-7.08-1.33-7.25-1.36c-1.28-.24-2.58-.37-3.88-.38-1.3-.02-2.6.08-3.88.29v.01l-.01-.01c-2.73.4-5.46.83-8.17 1.33l-20.99 4.2a59.971 59.971 0 0 0-32.2 18.01l-33.31 35.87c-3.03 3.26-2.81 8.37.48 11.36l32.37 29.43c3.16 2.87 8.02 2.76 11.04-.26l9.48-9.48c1.89-1.89 5.12-.55 5.12 2.12v136.76c0 4.42 3.58 8 8 8h128c4.42 0 8-3.58 8-8V191.36c0-2.67 3.23-4.01 5.12-2.12l9.48 9.48a7.994 7.994 0 0 0 11.04.26l32.37-29.43c3.29-2.99 3.51-8.1.48-11.36Zm-130.5-26.08h-.34.7H224.04Z" fill="#DD6A5A"></path>
                                    <path d="m252.03 98.87-14.35 2.69a74.08 74.08 0 0 1-27.37 0l-14.35-2.69c-2.56-.48-5.17-.51-7.74-.09 1.36 18.63 16.85 33.32 35.78 33.32s34.41-14.69 35.78-33.32c-2.57-.42-5.18-.39-7.74.09h-.01Z" fill="#C03D37"></path>
                                    <path d="m195.99 109.55 14.34 2.7c9.04 1.7 18.31 1.7 27.35 0l14.34-2.7c1.78-.33 3.58-.44 5.38-.33 1.27-3.27 2.09-6.77 2.35-10.43-2.56-.42-5.18-.39-7.73.09l-14.34 2.7c-9.04 1.7-18.31 1.7-27.35 0l-14.34-2.7c-2.55-.48-5.17-.51-7.73-.09.27 3.66 1.08 7.16 2.35 10.43 1.8-.1 3.61 0 5.38.33Z" fill="#CC5747"></path>
                                    <path d="M232.38 112.11h-16.76a1.62 1.62 0 0 0-1.62 1.62v7.76c0 .895.725 1.62 1.62 1.62h16.76a1.62 1.62 0 0 0 1.62-1.62v-7.76a1.62 1.62 0 0 0-1.62-1.62Z" fill="#fff"></path>
                                    <path d="M185.16 95.82c1.65-.29 3.18.86 3.45 2.52 2.73 17.09 17.53 30.16 35.39 30.16s32.66-13.06 35.39-30.16c.26-1.66 1.79-2.81 3.45-2.52l5.93 1.04c1.59.28 2.68 1.78 2.43 3.38-3.64 22.79-23.38 40.21-47.2 40.21-23.82 0-43.56-17.42-47.2-40.21-.25-1.6.84-3.1 2.43-3.38l5.93-1.04ZM95.82 155.74l-2.23 2.4c-3.03 3.26-2.81 8.37.48 11.36l32.37 29.43c3.16 2.87 8.02 2.76 11.04-.26l2.56-2.56-44.22-40.37Z" fill="#E8AF57"></path>
                                    <path d="m354.541 158.19-33.31-35.87a59.971 59.971 0 0 0-32.2-18.01l-17.92-3.58c-.57 3.35-1.49 6.59-2.72 9.67l12.12 2.42a59.971 59.971 0 0 1 32.2 18.01l33.31 35.87c2.32 2.49 2.73 6.07 1.32 8.95l6.71-6.1c3.29-2.99 3.51-8.1.48-11.36h.01ZM293.9 195.51a74.154 74.154 0 0 0-10.11 51.02l.04.27c.53 3.19 1.18 6.58 1.84 10.38 1.52 8.8 2.26 17.72 2.26 26.65V295c0 14-9.37 26.26-22.87 29.95a89.888 89.888 0 0 1-42.54 1.17l-15.36-3.29a90.172 90.172 0 0 0-38.42.15l-16.73 3.73v1.41c0 4.42 3.58 8 8 8h128c4.42 0 8-3.58 8-8v-136l-2.1 3.4-.01-.01Z" fill="#E87E69"></path>
                                    <path d="m352.26 155.74 2.23 2.4c3.03 3.26 2.81 8.37-.48 11.36l-32.37 29.43c-3.16 2.87-8.02 2.76-11.04-.26l-2.56-2.56 44.22-40.37Z" fill="#E8AF57"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0_894_1529">
                                    <path fill="#fff" d="M0 0h448v448H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        `}
                    </div>
                </div>

                <div class="${prefix_selector}__product-details">
                    <h3>${product.title}</h3>
                </div>

                <div class="${prefix_selector}__quantity-container">
                    <div class="${prefix_selector}__quantity-selector">
                        <button class="${prefix_selector}__quantity-btn ${prefix_selector}__minus-btn" data-product-id="${product.id}">-</button>
                        <input 
                            type="number" 
                            class="${prefix_selector}__quantity-input" 
                            value="0" 
                            min="0" 
                            data-product-id="${product.id}"
                            data-price="${product.variants[0].price}"
                        >
                        <button class="${prefix_selector}__quantity-btn ${prefix_selector}__plus-btn" data-product-id="${product.id}">+</button>
                    </div>
                </div>
                
                <div class="${prefix_selector}__price-per-item">${formatMoney(product.variants[0].price)}</div>
                <div class="${prefix_selector}__total-price" data-product-id="${product.id}">${formatMoney(0)}</div>
            `;
            productsGrid.appendChild(productRow);
        });

        // Add event listeners for quantity buttons
        attachQuantityEvents();
    }

    function attachQuantityEvents() {
        // Minus buttons
        popupOverlay.querySelectorAll(`.${prefix_selector}__minus-btn`).forEach(btn => {
            btn.addEventListener('click', function() {
                const productId = this.dataset.productId;
                const input = popupOverlay.querySelector(`.${prefix_selector}__quantity-input[data-product-id="${productId}"]`);
                let currentValue = parseInt(input.value);
                if (currentValue > 0) {
                    input.value = currentValue - 1;
                    updateProductTotal(productId);
                }
            });
        });

        // Plus buttons
        popupOverlay.querySelectorAll(`.${prefix_selector}__plus-btn`).forEach(btn => {
            btn.addEventListener('click', function() {
                const productId = this.dataset.productId;
                const input = popupOverlay.querySelector(`.${prefix_selector}__quantity-input[data-product-id="${productId}"]`);
                let currentValue = parseInt(input.value);
                input.value = currentValue + 1;
                updateProductTotal(productId);
            });
        });

        // Input changes
        popupOverlay.querySelectorAll(`.${prefix_selector}__quantity-input`).forEach(input => {
            input.addEventListener('change', function() {
                if (this.value < 0) this.value = 0;
                updateProductTotal(this.dataset.productId);
            });
            
            input.addEventListener('input', function() {
                if (this.value === '') return;
                if (this.value < 0) this.value = 0;
                updateProductTotal(this.dataset.productId);
            });
        });
    }

    function updateProductTotal(productId) {
        const input = document.querySelector(`.${prefix_selector}__quantity-input[data-product-id="${productId}"]`);
        const totalElement = document.querySelector(`.${prefix_selector}__total-price[data-product-id="${productId}"]`);
        const price = parseFloat(input.dataset.price);
        const quantity = parseInt(input.value);
        const total = quantity * price;
        
        totalElement.textContent = formatMoney(total);
        
        // Update cart items
        if (quantity > 0) {
            const product = currentProducts.find(p => p.id == productId);
            cartItems[productId] = {
                quantity: quantity,
                variantId: product ? product.variants[0].id : null
            };
        } else {
            delete cartItems[productId];
        }
        
        updateGrandTotal(productId);
    }

    function updateGrandTotal(productId) {
        let totalQuantity = 0;
        let grandTotal = 0;
        document.querySelectorAll(`.${prefix_selector}__quantity-input`).forEach(input => {
            const quantity = parseInt(input.value);
            const price = parseFloat(input.dataset.price);
            totalQuantity += quantity;
            grandTotal += quantity * price;
        });
        const qtyThreshold = Number(grandQuantityElement.dataset.qtyTrashhold);
        if(totalQuantity <= qtyThreshold ){
            grandQuantityElement.textContent = totalQuantity + "/" + qtyThreshold;
           }
        
           if(qtyThreshold < totalQuantity ){
            grandQuantityElement.textContent = formatMoney(grandTotal);    
        }
        if(totalQuantity < qtyThreshold ){
            addToCartBtn.disabled = true;
         }
         else{
         addToCartBtn.disabled = false;
         }   
        grandTotalElement.textContent = formatMoney(grandTotal);
        
        // Enable/disable add to cart button
    }

    function resetCart() {
        cartItems = {};
        const qtyThreshold = Number(grandQuantityElement.dataset.qtyTrashhold);

        if (grandQuantityElement) grandQuantityElement.textContent = '0/' + qtyThreshold;
        if (grandTotalElement) grandTotalElement.textContent = formatMoney(0);
        if (addToCartBtn) addToCartBtn.disabled = true;
    }

    function closePopup() {
        popupOverlay.classList.remove('active');
        document.body.style.overflow = 'auto';
    }

    // Add to cart functionality
    addToCartBtn.addEventListener('click', function() {
        if (this.disabled) return;
        
        const items = Object.keys(cartItems).map(productId => ({
            id: cartItems[productId].variantId,
            quantity: cartItems[productId].quantity,
            properties: {
                "Bundle": `${cl_title}`
            }

        })).filter(item => item.quantity > 0);

        if (items.length === 0) return;

        // Show loading state
        const originalText = this.innerHTML;
        this.innerHTML = '<span>מוסיף לעגלה...</span>';
        this.disabled = true;

        const cartDrawer = document.querySelector("cart-drawer");

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        // JSON body — required for multiple items
        config.body = JSON.stringify({
            items: items,
            ...(cartDrawer && {
                sections: cartDrawer.getSectionsToRender().map(s => s.id),
                sections_url: window.location.pathname
            })
        });

        // Add to cart via Shopify AJAX API
        fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(data => {
            closePopup();
            
            if(cartDrawer) {
                cartDrawer.setActiveElement(document.activeElement);
                cartDrawer.renderContents(data);
                if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
            }

            // Reset button
            setTimeout(() => {
                this.innerHTML = originalText;
            }, 2000);
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
            alert('שגיאה בהוספת פריטים לעגלה. אנא נסה שוב.');
            this.innerHTML = originalText;
            this.disabled = false;
        });
    });

});
